import type { MenuItem } from '../../types';

export const isActivePath = (path?: string, rootActivePath?: string): boolean => {
  const pathName = window.location.pathname;
  if (pathName === path) return true;

  // If option to be active on sub routes (child routes) of path is enabled, then we will do partial path matching
  if (rootActivePath) {
    return pathName.startsWith(rootActivePath);
  }

  return false;
};

export const findActiveItem = (items: MenuItem[]): MenuItem | undefined =>
  items.find((item) => {
    if (isActivePath(item.href)) {
      return true;
    }

    if (item.subitems && findActiveItem(item.subitems)) {
      return true;
    }

    return false;
  });
